import React from "react";
import { useDispatch } from "react-redux";
import type { Dispatch } from "redux";
import { useContextualExpandableContainer } from "~/components/Expandable/Expandable";
import type { ExpanderActions } from "~/components/form/Sections/reducers/expanders";
import { expanderActions } from "~/components/form/Sections/reducers/expanders";
export function useExpandExpanders(containerKey?: string) {
    const dispatch = useDispatch<Dispatch<ExpanderActions>>();
    const containerKeyFromContext = useContextualExpandableContainer();
    const containerKeyToUse = containerKey ?? containerKeyFromContext;
    return React.useCallback((expandersWithErrors: ReadonlyArray<string>) => {
        dispatch(expanderActions.onExpandExpanders({ containerKey: containerKeyToUse, expandersWithKeys: expandersWithErrors }));
    }, [containerKeyToUse, dispatch]);
}
